export default __webpack_public_path__ + "static/media/Spire of the Firmament.ac77afad.jpg";